<app-sub-section-header [text]="showAddressSubtitle ? getAddressTypeDescription(address.addressType) : ''">
    <ng-container buttons>
        <button class="btn btn-primary" *ngIf="!editMode && showEditButton" (click)="handleEditMode()">
            <iota-icon icon="pencil-square"></iota-icon>
        </button>
        <button *ngIf="!editMode && address.addressType !== AddressType.MAIN_ADDRESS" class="btn btn-error" (click)="deleteAddress()">
            <iota-icon icon="trash"></iota-icon>
        </button>
        <button *ngIf="editMode && showSaveButton" [disabled]="addressForm.invalid" class="btn btn-accent" (click)="saveEdit()">
            <iota-icon flaticon="floppy-disk" size="1x"> </iota-icon>
        </button>
        <button *ngIf="editMode && showSaveButton" class="btn btn-accent" (click)="cancelEdit()">
            <iota-icon icon="x-mark"></iota-icon>
        </button>
    </ng-container>
</app-sub-section-header>

<form class="w-full mb-10 grid grid-cols-12 justify-between items-start gap-2" [formGroup]="addressForm">
    <div class="flex flex-row items-center gap-2 col-span-12">
        <span class="min-w-[125px]" i18n>Name <span class="font-bold">*</span></span>
        <input type="text" class="flex-1 input input-bordered" formControlName="name1" />
    </div>
    <div class="flex flex-row items-center gap-2 col-span-12">
        <span class="min-w-[125px]" i18n>Name 2</span>
        <input type="text" class="flex-1 input input-bordered" formControlName="name2" />
    </div>

    <div class="col-span-12 flex justify-between gap-2">
        <div class="flex flex-row items-center gap-2 w-full">
            <span class="min-w-[125px]" i18n>Street <span class="font-bold">*</span></span>
            <input type="text" class="flex-1 input input-bordered" formControlName="street" />
        </div>

        <div class="flex flex-row items-center gap-2">
            <span class="min-w-[80px]" i18n>House no.</span>
            <input type="text" class="flex-1 input input-bordered" formControlName="houseNumber" />
        </div>
    </div>

    <div class="flex flex-row items-center gap-2 col-span-12">
        <span class="min-w-[125px]" i18n>Street 2:</span>
        <input type="text" class="flex-1 input input-bordered" formControlName="street2" />
    </div>

    <div class="col-span-12 flex justify-between gap-2">
        <div class="flex flex-row items-center gap-2">
            <span class="min-w-[125px]" i18n>Postal Code<span class="font-bold">*</span></span>
            <input type="text" class="flex-1 input input-bordered" formControlName="zipCode" />
        </div>
        <div class="flex flex-row items-center gap-2 w-full">
            <span class="min-w-[30px]" i18n>City <span class="font-bold">*</span></span>
            <input type="text" class="flex-1 input input-bordered" formControlName="city" />
        </div>
    </div>

    <div class="col-span-12">
        <iota-dropdown
            labelWidth="125px"
            [options]="countryOptions"
            [selectedValue]="addressForm.get('countryCode').value"
            placeholder="Select Country"
            [disabled]="!editMode"
            label="Country *"
            (selectionChange)="onCountryChange($event)"
            i18n-placeholder
            i18n-label
        >
        </iota-dropdown>
    </div>
</form>
<p class="w-full text-end text-xs font-bold -mt-5 mb-5" i18n>* required information</p>
